import { defaultIconColor } from 'assets/constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

type PropsType = SVGComponentPropsType & {
  outlined?: boolean;
};

export default ({
  size = defaultSize,
  color = defaultIconColor,
  outlined = false,
  viewBox = `0 0 ${defaultSize} ${defaultSize}`,
  ...props
}: PropsType) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={viewBox} fill="none" {...props}>
    {outlined && <circle cx="12" cy="12" r="11" stroke={color} strokeWidth="2" />}
    <path d="m8 16 8-8" stroke={color} strokeWidth="2" />
    <circle cx="8.5" cy="8.5" r="1.5" stroke={color} strokeWidth="2" />
    <circle cx="15.5" cy="15.5" r="1.5" stroke={color} strokeWidth="2" />
  </svg>
);
